import { ApolloError } from "@apollo/client";

const DEFAULT_ERROR_MESSAGE = "Error desconocido";

export function handleErrorMessage(error: unknown): never {
	let errorMessage = DEFAULT_ERROR_MESSAGE;

	if (error instanceof ApolloError) {
		errorMessage = getApolloErrorMessage(error);
	} else if (error instanceof Error) {
		errorMessage = error.message;
	}

	throw new Error(errorMessage);
}

function getApolloErrorMessage(error: ApolloError): string {
	if (error.graphQLErrors.length > 0) {
		return error.graphQLErrors.map(({ message }) => message).join(", ");
	}

	if (error.networkError) {
		if ("result" in error.networkError) {
			if (typeof error.networkError.result === "string") {
				return error.networkError.result;
			}

			const errors = error.networkError.result.errors;
			if (
				Array.isArray(errors) &&
				errors.length > 0 &&
				"extensions" in errors[0]
			) {
				return (errors as ApolloError[]).map((err) => err.message).join(", ");
			}
		} else if ("message" in error.networkError) {
			return error.networkError.message;
		}
	}

	return DEFAULT_ERROR_MESSAGE;
}
